import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IProjectAllocationChartData } from '../../../../models/project/project-dashboard.model';
import _ from 'lodash';
import { FIELD_VALUE_UNASSIGNED_LOWER } from '../../../../modules/catch-core/data/constants/blueprint.constants';
import { ProjectService } from '../../../../../app/services/project.service';
@Component({
  selector: 'app-project-allocation',
  templateUrl: './project-allocation.component.html',
  styleUrls: ['./project-allocation.component.scss'],
  standalone: false,
})
export class ProjectAllocationComponent implements OnInit, OnChanges {
  @Input() projectAllocationChartData!: IProjectAllocationChartData[];

  colorScheme = {
    domain: ['#6c7481', '#c1cfe9', '#6dbd4a'], // Adjust colors if needed
  };

  constructor(private projectService: ProjectService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.projectAllocationChartData && changes.projectAllocationChartData.currentValue) {
      this.sortProjectAllocationChartData();
      this.projectAllocationChartData = this.getRoundedEdgeBar(this.projectAllocationChartData);
    }
  }

  public sortProjectAllocationChartData(): void {
    this.projectAllocationChartData.sort((a, b) => {
      // Use fullName for comparison since that's the displayed value
      const nameA = ((a?.fullName || a?.name) ?? '').toLowerCase();
      const nameB = ((b?.fullName || b?.name) ?? '').toLowerCase();

      // Function to determine priority
      const getPriority = (name: string): number => {
        if (name.includes(FIELD_VALUE_UNASSIGNED_LOWER)) return 1;
        if (name.includes('inactive')) return 2;
        return 3;
      };

      const priorityA = getPriority(nameA);
      const priorityB = getPriority(nameB);

      // Compare based on priority
      if (priorityA !== priorityB) {
        return priorityA - priorityB;
      }

      // If priorities are equal, sort alphabetically
      return nameA.localeCompare(nameB);
    });
  }

  public yAxisTickFormatting(val: number): number | string {
    if (val % 1 > 0) return '';
    return val;
  }

  public getRoundedEdgeBar(data: IProjectAllocationChartData[]): IProjectAllocationChartData[] {
    return (
      data?.map((group) => ({
        ...group,
        series:
          group?.series?.map((d) => ({
            ...d,
            roundEdges: true,
          })) ?? [],
      })) ?? []
    );
  }

  public onSelect(event: any): void {
    console.log(event);
    this.projectService.setProjectAllocationSelectedOwner(event);
  }
}
